// utils/preloadAvatarsAndAnimations.js

const avatarUrls = [
  "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2FCharactaerMovementSpritesheet.png?alt=media&token=88abaab6-a5ab-4372-bee3-4bc61674e70a",
  "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fblue.png?alt=media&token=ec673ef0-c852-4340-9934-a158f293dd80",
  "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fgreen.png?alt=media&token=b504236c-a42f-4a2c-a2bd-9742b489a398",
  "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Forange.png?alt=media&token=fcb3ee5e-bbc3-4937-8aac-ac51a0b645c2",
  "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fpink.png?alt=media&token=b7d56c15-9325-48ab-a361-bf12f0fd102b",
  "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fpurple.png?alt=media&token=efa955ed-e87a-4ef2-8686-b2bd0c114593",
  "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fred.png?alt=media&token=8bcdf7e4-1ff8-47a4-87e6-0b9bb8b35a7f",
  "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fvoid.png?alt=media&token=4f95383c-f755-41b9-97a9-346ad81db84c",
  "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fwhite.png?alt=media&token=4057c10a-9333-44da-8e89-9f06282fb184",
  "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/avatars%2Fyellow.png?alt=media&token=b872e3e6-9ab2-41c1-82ab-a3ca63ab7186",
];

export const preloadAvatars = (scene, SPRITES_MAP) => {
  Object.entries(SPRITES_MAP).forEach(([key, spritePath]) => {
    scene.load.spritesheet(`avatar-${key}`, spritePath, {
      frameWidth: 128,
      frameHeight: 192,
    });
  });
};

export const createAvatarAnimations = (scene) => {
  avatarUrls.forEach((url) => {
    const fileName = url.split("/").pop().split("?")[0];
    const key = `avatar_${fileName.replace(".png", "")}`;

    ["down", "left", "right", "up"].forEach((dir, i) => {
      const animKey = `walk-${key}-${dir}`;
      if (!scene.anims.exists(animKey)) {
        scene.anims.create({
          key: animKey,
          frames: scene.anims.generateFrameNumbers(key, {
            start: 4 * i,
            end: 4 * i + 3,
          }),
          frameRate: 8,
          repeat: -1,
        });
      }
    });
  });
};
